import { ContainerComponent, wrap } from 'AppReact';
import Schema from 'AppReact/schema';
import {Input, InputError} from 'molecules';
import { Seprator, SubSectionLabel } from '../../../../common/atoms';
import { SubsectionHeader } from '../../../../common/molecules';
import { FieldWrapper } from '../../../../common/wrappers';
import Controller from './controller';
import { petsSechema, defaultPets } from '../../../../types'
import { GenericWrapper } from 'wrappers';
import { isLastItem } from "../../../../utils";

const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);

export const definition = ({
    controller: Controller,
    name: "Pet",
    initialProps: ({ language, pet, pets, petIndex }) => ({ language, pet, pets, petIndex }),
    props: {
        pet: Schema(petsSechema, 'object', { defaultValue: defaultPets }),
        pets: Schema(petsSechema, 'array'),
        petIndex: Schema('integer', 'primitive'),
        language: Schema( {}, 'object'),

    },
    elements: [
        {
            wrapper: GenericWrapper,
            name: 'PetsForm',
            elements: [
                {
                    component: SubSectionLabel,
                    name: 'SubSectionLabel',
                    renderIf: ({ pets, petIndex }) => pets && pets?.length> 0 && petIndex == 0,
                    displayValue: ({ pet }) => pet?.name || "Pet name",
                },
                {
                    component: SubsectionHeader,
                    name: 'DeleteButton',
                    renderIf: ({ pet, pets, petIndex }) => pets && pets?.length> 0 && petIndex !== 0,
                    bindings: ({ pet, pets, petIndex }) => ({ label: pet?.name || "Pet name", resourceList: pets, petIndex })
                },
                {
                    component: WrappedInput,
                    name: 'Name',
                    bindings: ({ language, pets, pet, petIndex }) => ({petIndex, pets, pet, label: `${ language?.pet || 'Name'}:`, value: pet.name })
                },
                {
                    component: WrappedInputError,
                    name: 'NameError',
                    bindings: ({ pet }) => ({ error: pet.nameError }),
                    renderIf: ({ pet, onReview }) => !!pet.nameError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'Type',
                    bindings: ({ language, pets, pet, petIndex }) => ({petIndex, pets, pet, label: `${ language?.type || 'Type'}:`, value: pet.type })
                },
                {
                    component: WrappedInputError,
                    name: 'TypeError',
                    bindings: ({ pet }) => ({ error: pet.typeError }),
                    renderIf: ({ pet, onReview }) => !!pet.typeError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'Breed',
                    bindings: ({ language, pets, pet, petIndex }) => ({petIndex, pets, pet, label: `${ language?.breed || 'Breed'}:`, value: pet.breed })
                },
                {
                    component: WrappedInputError,
                    name: 'BreedError',
                    bindings: ({ pet }) => ({ error: pet.breedError }),
                    renderIf: ({ pet, onReview }) => !!pet.breedError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'Weight',
                    bindings: ({ language, pets, pet, petIndex }) => ({petIndex, pets, pet, label: `${ language?.weight || 'Weight'}:`, value: pet.weight })
                },
                {
                    component: WrappedInputError,
                    name: 'WeightError',
                    bindings: ({ pet }) => ({ error: pet.weightError }),
                    renderIf: ({ pet, onReview }) => !!pet.weightError && !onReview
                },
            ]
        },
        {
            component: Seprator,
            name: 'Seprator',
            displayValue: () => '',
            renderIf: ({ pets, pet }) => isLastItem({ resource: pet, resourceList: pets })
        },
    ],
})

export default ContainerComponent(definition);
